import { Api } from "../config/request";

export default {
    getCache(key) {
        return Api.get(`/ofs/cache/get/${key}`);
    },
    setCache(payload) {
        return Api.post(`/ofs/cache/set`, payload);
    },
    deleteCache(key) {
        return Api.post(`/ofs/cache/delete/${key}`);
    },

}

